import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

export default function PrivacyNotice() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    try { if (!localStorage.getItem("pm_privacy_ok")) setShow(true); } catch {}
  }, []);
  if (!show) return null;
  const ok = () => { try { localStorage.setItem("pm_privacy_ok", "1"); } catch {} setShow(false); };
  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] p-3 pointer-events-none" data-testid="privacy-notice">
      <div className="pointer-events-auto max-w-2xl mx-auto bg-thali-ink text-white rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3 text-sm">
        <span className="flex-1">We use basic analytics to improve this tool. See our <Link to="/privacy" className="underline font-semibold">Privacy Policy</Link>.</span>
        <button onClick={ok} className="shrink-0 bg-thali-saffron text-white font-bold rounded-lg px-4 py-1.5" data-testid="privacy-ok">OK</button>
        <button onClick={ok} className="shrink-0 opacity-70" aria-label="Dismiss"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
